import { defineStore } from 'pinia'

type RouteEvent = {
  type: 'route'
  timestamp: Date
  data: {
    from: string
    to: string
  }
}
type ButtonEvent = {
  type: 'button'
  timestamp: Date
  data: {
    page: string
    name: string
  }
}
type Event = ButtonEvent | RouteEvent
type SpyState = {
  events: Event[]
}

export const useSpyStore = defineStore('spy', {
  state: (): SpyState => ({
    events: [],
  }),
  actions: {
    addEvent(event: Event) {
      this.events.push(event)
    },
    resetStoreState() {
      this.$reset()
    },
  },
})
